import api from "./api";
import API_ROUTES from "./apiRoutes";
import { toast } from "react-toastify";

export const importUnitsFile = async (file, meta = {}, onUploadProgress) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    if (meta?.societyId) formData.append("society_id", String(meta.societyId));
    if (meta?.towerId) formData.append("tower_id", String(meta.towerId));

    const res = await api.post(API_ROUTES.import.units, formData, { onUploadProgress });

    toast.success("Import completed successfully");
    return res.data;

  } catch (error) {
    console.error(error);

    const message =
      error?.data?.error ||
      error?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      "Import failed";

    toast.error(message);

    throw error;
  }
};
